const HomeworksTypes = {
  SET_HOMEWORKS_LOADING: 'HOMEWORKS/SET_HOMEWORKS_LOADING',
  SET_HOMEWORKS_FAILURE: 'HOMEWORKS/SET_HOMEWORKS_FAILURE',
  SET_HOMEWORKS_SUCCESS: 'HOMEWORKS/SET_HOMEWORKS_SUCCESS',
};

export default HomeworksTypes;